import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Loader2 } from 'lucide-react';

const QRCode = ({ qrCodeUrl, isLoading, error }) => {
  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center p-6 min-h-[200px]">
        <div
          className="w-[200px] h-[200px] rounded-2xl flex items-center justify-center mb-4"
          style={{
            background: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(15px)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
          }}
        >
          <Loader2 className="h-16 w-16 text-white animate-spin" />
        </div>
        <p className="text-sm text-white/80 text-center">
          生成二维码中...
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center p-6 min-h-[200px]">
        <div
          className="w-[200px] h-[200px] rounded-2xl flex items-center justify-center mb-4"
          style={{
            background: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(15px)',
            border: '1px solid rgba(255, 0, 0, 0.3)',
          }}
        >
          <span className="text-2xl text-white/90">
            ⚠️
          </span>
        </div>
        <p className="text-base text-white/90 text-center mb-1">
          生成二维码失败
        </p>
        <p className="text-sm text-white/70 text-center">
          {error}
        </p>
      </div>
    );
  }

  if (!qrCodeUrl) {
    return (
      <div className="flex flex-col items-center justify-center p-6 min-h-[200px]">
        <div
          className="w-[200px] h-[200px] rounded-2xl flex items-center justify-center mb-4"
          style={{
            background: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(15px)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
          }}
        >
          <span className="text-lg text-white/60 text-center">
            二维码
          </span>
        </div>
        <p className="text-sm text-white/70 text-center">
          没有可用的二维码
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center p-6">
      {/* QR Code Display */}
      <div
        className="w-[200px] h-[200px] rounded-2xl flex items-center justify-center mb-4 relative overflow-hidden"
        style={{
          background: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(15px)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
        }}
      >
        {/* Background overlay */}
        <div
          className="absolute inset-0 rounded-2xl"
          style={{
            background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05))',
          }}
        />
        <div
          className="absolute inset-[1px] rounded-[15px] z-[1]"
          style={{
            background: 'rgba(0, 0, 0, 0.3)',
          }}
        />
        {/* QR Code */}
        <div className="relative z-[2]">
          <QRCodeSVG
            value={qrCodeUrl}
            size={160}
            level="M"
            includeMargin={true}
            bgColor="rgba(255, 255, 255, 0.9)"
            fgColor="#000000"
          />
        </div>
      </div>

      <p className="text-sm text-white/80 text-center font-medium">
        使用微信扫描二维码登录
      </p>
    </div>
  );
};

export default QRCode;
